import React from "react";
import classNames from "classnames";
import styles from "./style.scss";
import { Clickable } from "../Clickable";

export const Link = ({ onClick, to, href, target, children, silent, block }) => {
    return (
        <Clickable
            onClick={onClick}
            link={to}
            href={href}
            target={target}
            className={classNames(styles.base, {
                [styles.silent]: silent,
                [styles.block]: block
            })}
        >
            {children}
        </Clickable>
    );
};
